import { Header } from 'components'
import Accessibility from 'components/Accessibility'
import { Device } from 'components/Device'
import Footer from 'components/Footer'
import SearchFamilies from 'components/UI/SearchFamilies'
import './styles.scss'

function Search() {
  const device = Device.useDevice()

  return (
    <>
      <Accessibility />
      <main className={`container-home ${device.prefix()}`}>
        <Header />
        <SearchFamilies />
      </main>

      <Footer />
    </>
  )
}

export default Search
